import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'

import {fetchDataIfReady, setAlert} from '../modules/fetch.action.js'
import {handleChange} from '../modules/functions.js'
import ModalWrapper from './Modal_Wrapper.js'
import Login from './ModalAccount_Login.js'
import Register from './ModalAccount_Register.js'
import Recover from './ModalAccount_Recover.js'
import Reset from './ModalAccount_Reset.js'
import Verify from './ModalAccount_Verify.js'

const e = React.createElement;

// @TODO_WHN laad animatie op login button? denk dat het mooi zou zijn als ik de animatie met 3-5 bars (en groter) _in_ de button kan krijgen
// @TODO_WHN handleClickOutside staat op ID, dus als je op de statuscode van een alert klikt gaan ze allebei dicht. classes gebruiken?
// @TODO_WHN bij gefaalde login door nog-niet-geverifieerd, switchContent naar verify

function ModalAccount(props) {
  React.Component.constructor.call(this);

  this.state = {
    email:"",
    password:"",
    firstname:"",
    lastname:"",
    content: props.modal_content,
    reset_token: props.reset_token,
    reset_password: "",
    verify_code: "",
  };

  this.handleLogin = this.handleLogin.bind(this);
  this.handleRegister = this.handleRegister.bind(this);
  this.handleRecover = this.handleRecover.bind(this);
  this.handleReset = this.handleReset.bind(this);
  this.handleVerify = this.handleVerify.bind(this);
  this.switchContent = this.switchContent.bind(this);
}
ModalAccount.prototype = Object.create(React.Component.prototype);

ModalAccount.prototype.componentWillReceiveProps = function(nextProps) {
  if(this.props.modal_content !== nextProps.modal_content) {
    this.setState({content:nextProps.modal_content});
  }
}

ModalAccount.prototype.render = function() {
  var lang = "NL";
  if(this.props.app_language) lang = this.props.app_language;
  
  var login = e(Login, {
    key:"acm-login",
    email:this.state.email,
    password:this.state.password,
    login_is_fetching:this.props.login_is_fetching,
    handleChange:handleChange.bind(null, this),
    handleLogin:this.handleLogin,
    switchContent:this.switchContent,
    language:lang
  });

  var register = e(Register, {
    key:"acm-register",
    email:this.state.email,
    password:this.state.password,
    firstname:this.state.firstname,
    lastname:this.state.lastname,
    register_is_fetching:this.props.register_is_fetching,
    handleChange:handleChange.bind(null, this),
    handleRegister:this.handleRegister,
    switchContent:this.switchContent,
    language:lang
  });

  var recover = e(Recover, {
    key:"acm-recover",
    email:this.state.email,
    recover_is_fetching:this.props.recover_is_fetching,
    handleChange:handleChange.bind(null, this),
    handleRecover:this.handleRecover,
    switchContent:this.switchContent,
    language:lang
  });

  var reset = e(Reset, {
    key:"acm-reset",
    reset_password:this.state.reset_password,
    reset_is_fetching:this.props.reset_is_fetching,
    handleChange:handleChange.bind(null, this),
    handleReset:this.handleReset,
    language:lang
  });

  var verify = e(Verify, {
    key:"acm-verify",
    email:this.state.email,
    verify_code:this.state.verify_code,
    handleChange:handleChange.bind(null, this),
    handleVerify:this.handleVerify,
    language:lang
  });

  var content = login;
  if(this.state.content === "register") {
    content = register;
  } else if(this.state.content === "recover") {
    content = recover;
  } else if(this.state.content === "reset") {
    content = reset;
  } else if(this.state.content === "verify") {
    content = verify;
  }

  if(this.props.shouldShow) {
    return e(ModalWrapper, {
      switchState:this.props.close,
      ribbon:this.props.ribbon,
      header:this.props.header,
      headerimg:this.props.headerimg
    }, content);
  } else {
    return null;
  }
}

ModalAccount.prototype.handleLogin = function(e) {
  e.preventDefault();
  if(this.state.email.indexOf("\\") >= 0 || this.state.email.indexOf("'") >= 0 || this.state.email.indexOf("\"") >= 0 ||
  this.state.password.indexOf("\\") >= 0 || this.state.password.indexOf("'") >= 0 || this.state.password.indexOf("\"") >= 0) {
    this.props.setAlert("Used invalid characters: \\ , ' , \" ."); //i18n: Ongeldige tekens gebruikt
  } else {
    if(this.props.login_is_fetching === false || this.props.login_is_fetching === null) { // @TODO_WHN knop ook disablen als andere endpoints bezig zijn
      this.props.fetchDataIfReady(this.props.config.api_token, "login", "POST", this.props.config.api_url+"/login", JSON.stringify({email:this.state.email, password:this.state.password}), null, true);
    }
  }
}

ModalAccount.prototype.handleRegister = function(e) {
  e.preventDefault();
  var empty_fields = this.state.email.trim() === "" || this.state.password.trim() === "" || this.state.firstname.trim() === "" || this.state.lastname.trim() === "";

  if(!empty_fields) {
    if(this.state.email.indexOf("\\") >= 0 || this.state.email.indexOf("'") >= 0 || this.state.email.indexOf("\"") >= 0 ||
    this.state.password.indexOf("\\") >= 0 || this.state.password.indexOf("'") >= 0 || this.state.password.indexOf("\"") >= 0 ||
    this.state.firstname.indexOf("\\") >= 0 || this.state.firstname.indexOf("'") >= 0 || this.state.firstname.indexOf("\"") >= 0 ||
    this.state.lastname.indexOf("\\") >= 0 || this.state.lastname.indexOf("'") >= 0 || this.state.lastname.indexOf("\"") >= 0) {
      this.props.setAlert("Used invalid characters: \\ , ' , \" ."); // i18n: Ongeldige tekens gebruikt
    } else {
      var valid_email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.state.email);
      var valid_tld = this.state.email.indexOf("@") > -1 && this.state.email.split("@")[1].indexOf(".") > -1 && this.state.email.split("@")[1].split(".")[this.state.email.split("@")[1].split(".").length-1].length > 1;
      var valid_tld_alpha = false;
      if(valid_tld) {
        var tld = this.state.email.split("@")[1].split(".")[this.state.email.split("@")[1].split(".").length-1];
        valid_tld_alpha = tld.replace(/[^a-zA-Z]/gi, '').length === tld.length;
      }
      if(valid_email && valid_tld && valid_tld_alpha) {
        if(this.props.register_is_fetching === false || this.props.register_is_fetching === null) {
          this.props.fetchDataIfReady(this.props.config.api_token, "register", "POST", this.props.config.api_url+"/register", JSON.stringify({email:this.state.email, password:this.state.password, firstname:this.state.firstname, lastname:this.state.lastname}), null, true);
          this.switchContent("verify", e);
        }
      } else {
        this.props.setAlert("Invalid email address."); // i18n: Ongeldig emailadres
      }
    }
  } else {
    this.props.setAlert("Please fill in all fields."); // i18n: Vul alsjeblieft alle velden in
  }
}

ModalAccount.prototype.handleRecover = function(e) {
  // @TODO_WHN wait for API response before switching content
  e.preventDefault();
  if(this.state.email.indexOf("\\") >= 0 || this.state.email.indexOf("'") >= 0 || this.state.email.indexOf("\"") >= 0) {
    this.props.setAlert("Used invalid characters: \\ , ' , \" ."); // i18n: Ongeldige tekens gebruikt
  } else {
    if(this.props.recover_is_fetching === false || this.props.recover_is_fetching === null) {
      this.props.fetchDataIfReady(this.props.config.api_token, "recover", "POST", this.props.config.api_url+"/recover-password", JSON.stringify({email:this.state.email}), null, true, false, true);
      this.switchContent("login", e);
    }
  }
}

ModalAccount.prototype.handleReset = function(e) {
  // @TODO_WHN wait for API response before switching content
  e.preventDefault();
  if(this.state.reset_token.indexOf("\\") >= 0 || this.state.reset_token.indexOf("'") >= 0 || this.state.reset_token.indexOf("\"") >= 0 ||
  this.state.reset_password.indexOf("\\") >= 0 || this.state.reset_password.indexOf("'") >= 0 || this.state.reset_password.indexOf("\"") >= 0) {
    this.props.setAlert("Used invalid characters: \\ , ' , \" ."); // i18n: Ongeldige tekens gebruikt
  } else {
    if(this.props.reset_is_fetching === false || this.props.reset_is_fetching === null) {
      this.props.fetchDataIfReady(this.props.config.api_token, "reset", "POST", this.props.config.api_url+"/reset-password", JSON.stringify({token:this.state.reset_token, password:this.state.reset_password}), null, true, false, true);
      this.switchContent("login", e);
    }
  }
}

ModalAccount.prototype.handleVerify = function(e, verify_code) {
  // @TODO_WHN wait for API response before switching content
  e.preventDefault();
  if(this.state.email.indexOf("\\") >= 0 || this.state.email.indexOf("'") >= 0 || this.state.email.indexOf("\"") >= 0 ||
  verify_code.indexOf("\\") >= 0 || verify_code.indexOf("'") >= 0 || verify_code.indexOf("\"") >= 0) {
    this.props.setAlert("Used invalid characters: \\ , ' , \" ."); // i18n: Ongeldige tekens gebruikt
  } else {
    if(this.props.verify_is_fetching === false || this.props.verify_is_fetching === null) {
      this.props.fetchDataIfReady(this.props.config.api_token, "verify", "POST", this.props.config.api_url+"/verify", JSON.stringify({email:this.state.email, code:verify_code}), null, true, false, true);
      this.switchContent("login", e);
    }
  }
}

ModalAccount.prototype.switchContent = function(new_state, e) {
  e.preventDefault();
  this.setState({content:new_state})
}


function mapStateToProps(state) {
  var login_is_fetching = null, register_is_fetching = null, recover_is_fetching = null, reset_is_fetching = null, verify_is_fetching = null;
  if(state.apiData["login"] !== undefined && state.apiData["login"].isFetching !== undefined) {
    login_is_fetching = state.apiData["login"].isFetching;
  }
  if(state.apiData["register"] !== undefined && state.apiData["register"].isFetching !== undefined) {
    register_is_fetching = state.apiData["register"].isFetching;
  }
  if(state.apiData["recover"] !== undefined && state.apiData["recover"].isFetching !== undefined) {
    recover_is_fetching = state.apiData["recover"].isFetching;
  }
  if(state.apiData["reset"] !== undefined && state.apiData["reset"].isFetching !== undefined) {
    reset_is_fetching = state.apiData["reset"].isFetching;
  }
  if(state.apiData["verify"] !== undefined && state.apiData["verify"].isFetching !== undefined) {
    verify_is_fetching = state.apiData["verify"].isFetching;
  }
  return {
    login_is_fetching: login_is_fetching,
    register_is_fetching: register_is_fetching,
    recover_is_fetching: recover_is_fetching,
    reset_is_fetching: reset_is_fetching,
    verify_is_fetching: verify_is_fetching,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    push,
    setAlert,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAccount)



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/ModalAccount.js
// module id = 214
// module chunks = 0